import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Mail, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "General Inquiry", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.post("/contact", form);
      setSubmitted(true);
    } catch (err) {
      alert("Couldn't send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-grain min-h-screen" data-testid="contact-page">
      <Header />
      <main className="py-16 md:py-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-12">
          <div className="relative">
            <div className="corner-bracket tl" />
            <div className="pt-6 pb-2">
              <span className="pill">Get In Touch</span>
              <h1 className="mt-5 font-display font-black text-white text-5xl tracking-tighter leading-[1.05]">
                Got a question? <br /><span className="text-[#3B9EFF]">We answer in 24 hours.</span>
              </h1>
              <p className="mt-5 text-[#A0AABF] leading-relaxed">
                Use the form, or just email us directly. We don't ghost.
              </p>
              <a
                href="mailto:contentsnapbrand@gmail.com"
                className="mt-6 inline-flex items-center gap-3 text-[#3B9EFF] hover:underline"
                data-testid="contact-email-link"
              >
                <Mail size={18} /> contentsnapbrand@gmail.com
              </a>
              <div className="mt-10 snap-card">
                <p className="font-accent text-xs text-[#3B9EFF]">RESPONSE TIME</p>
                <p className="font-display text-3xl font-bold mt-1">Under 24 hrs.</p>
                <p className="text-[#A0AABF] text-sm mt-2">Most messages get a reply within 4 hours during business days.</p>
              </div>
            </div>
          </div>
          <div className="snap-card">
            {submitted ? (
              <div className="text-center py-10" data-testid="contact-success">
                <h2 className="font-display text-3xl font-bold text-[#3B9EFF]">Message sent.</h2>
                <p className="mt-3 text-[#A0AABF]">We'll get back to you within 24 hours.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
                <div>
                  <label className="font-accent text-xs text-[#A0AABF]">YOUR NAME</label>
                  <input
                    required
                    className="snap-input mt-2"
                    placeholder="Jane Doe"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    data-testid="contact-name"
                  />
                </div>
                <div>
                  <label className="font-accent text-xs text-[#A0AABF]">EMAIL</label>
                  <input
                    required
                    type="email"
                    className="snap-input mt-2"
                    placeholder="you@business.com"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    data-testid="contact-email"
                  />
                </div>
                <div>
                  <label className="font-accent text-xs text-[#A0AABF]">SUBJECT</label>
                  <input
                    className="snap-input mt-2"
                    placeholder="How can we help?"
                    value={form.subject}
                    onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    data-testid="contact-subject"
                  />
                </div>
                <div>
                  <label className="font-accent text-xs text-[#A0AABF]">MESSAGE</label>
                  <textarea
                    required
                    rows={5}
                    className="snap-input mt-2 resize-none"
                    placeholder="Tell us about your business or ask anything..."
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    data-testid="contact-message"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn-primary w-full justify-center"
                  data-testid="contact-submit"
                >
                  {loading ? "Sending..." : "Send Message"} <ArrowRight size={18} />
                </button>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
